<div class="visually-hidden"
     role="region"
     aria-live="polite"
     id="pageInfo" [innerHTML]="pageinfo"></div>

<section *ngIf="isReady">
  <div class="gd__container gd--ccgap">
    <div class="gd__container">
      <div class="mcbx inleiding">
        <h1 class="mcbx__title" [innerHTML]="pageTitle"></h1>
        <div class="richtext" [innerHTML]="pageContent"></div>
      </div>
    </div>

    <div class="gd__container">
      <div *ngIf="filterCurrent.length > 0" class="mcbx">
        <h2 class="mcbx__title" [innerHTML]="meerTipsTitle"></h2>
      </div>
      <div *ngIf="filterCurrent.length > 0" class="gd__container gd--13">
        <div *ngFor="let tip of filterCurrent" class="cc__tip">
          <h3 class="cct__title" [innerHTML]="tip.content.titleShort"></h3>
          <div class="richtext" [innerHTML]="tip.content.contentShort"></div>
          <div class="cct__actions">
            <button (click)="goToTip(tip.id)" 
                    class="button button--text right-icon" 
                    id="ipoclick-btn-{{paza}}-{{pagename}}-tips_tip_{{tip.id}}"
                    attr.aria-label="{{tipLinkAria}} {{tip.content.titleShort}}"
                    [innerHTML]="tipLinkText"></button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="gd__container">
      <div class="mcbx">
        <h2 class="mcbx__title" [innerHTML]="nextTitle"></h2>
        <div class="mcbx__actions">
          <button (click)="goToOverzicht()" 
              class="button" 
              id="ipoclick-btn-{{paza}}-{{pagename}}-{{currentVMModule.key}}_tips_overzicht"
              attr.aria-label="{{nextOverzicht}}"
              [innerHTML]="nextOverzicht"></button>
        </div>
      </div>
    </div>
  </div>
</section>
